export default __webpack_public_path__ + "static/dan-abramov-bc11fa96b79b67256f4a72f4b22ccd1d.jpg";